/** TR03 copy (one group per control; a ticket edits only its own file). */
export const tr03PtBr = {
  title: 'Extrato e razão na mesma data de corte',
  description:
    'Saldo do extrato contra o saldo contábil da conta bancária, por conta, com itens de prazo separados da diferença não explicada.',
  reasons: {
    UNEXPLAINED_RESIDUAL: 'Diferença não explicada',
    TIMING_ITEMS_OPEN: 'Itens de prazo em aberto (movimentos pendentes)',
    PROVIDER_REMOVED_ACTIVE_GL: 'Movimento removido pelo banco ainda lançado no razão',
    UNREMEASURED_FX: 'Variação cambial não reavaliada',
    BANK_GL_ACCOUNT_UNMAPPED: 'Conta bancária sem conta contábil mapeada',
    STATEMENT_BALANCE_MISSING: 'Sem saldo de extrato na data de corte',
    STATEMENT_STALE: 'Extrato desatualizado',
    FX_RATE_MISSING: 'Sem cotação de fechamento para converter o saldo',
  },
  observations: {
    TR03_PROVEN_ACCOUNTS: 'Contas comparadas: {{count}}',
    TR03_STATEMENTS_NOT_CLOSED: 'Extratos do mês ainda não fechados: {{count}}',
    TR03_SHARED_GL_ACCOUNT:
      'Contas que compartilham a conta contábil com outra (não comparadas): {{count}}',
    TR03_PROOF_UNREADABLE: 'Contas cuja prova de saldo não pôde ser lida: {{count}}',
    TR03_PERIOD_IN_PROGRESS: 'O período ainda está em andamento: a data de corte não chegou.',
    TR03_RESTRICTED_ACCOUNT_FINDINGS: 'Pendências em contas com acesso restrito: {{count}}',
  },
};

export const tr03En: typeof tr03PtBr = {
  title: 'Statement and ledger at the same cutoff',
  description:
    'Statement balance against the bank GL balance, per account, with timing items kept apart from the unexplained difference.',
  reasons: {
    UNEXPLAINED_RESIDUAL: 'Unexplained difference',
    TIMING_ITEMS_OPEN: 'Open timing items (pending movements)',
    PROVIDER_REMOVED_ACTIVE_GL: 'Movement removed by the bank still posted in the ledger',
    UNREMEASURED_FX: 'Exchange difference not remeasured',
    BANK_GL_ACCOUNT_UNMAPPED: 'Bank account without a mapped GL account',
    STATEMENT_BALANCE_MISSING: 'No statement balance at the cutoff',
    STATEMENT_STALE: 'Statement out of date',
    FX_RATE_MISSING: 'No closing rate to convert the balance',
  },
  observations: {
    TR03_PROVEN_ACCOUNTS: 'Accounts compared: {{count}}',
    TR03_STATEMENTS_NOT_CLOSED: 'Month statements not closed yet: {{count}}',
    TR03_SHARED_GL_ACCOUNT:
      'Accounts sharing their GL account with another (not compared): {{count}}',
    TR03_PROOF_UNREADABLE: 'Accounts whose balance proof could not be read: {{count}}',
    TR03_PERIOD_IN_PROGRESS: 'The period is still in progress: the cutoff has not been reached.',
    TR03_RESTRICTED_ACCOUNT_FINDINGS: 'Open items on restricted-access accounts: {{count}}',
  },
};
